export enum Timezone {
  userInfoTimezone = 'SignUp/UserInfo' // 更改個人時區
}
